import * as Icons from 'lucide-react';

import React from 'react';

import {
  type GroupCategory,
  type LucideIconName,
  getGroupCategoryIconName,
} from '@splitfiesta/shared';

/**
 * Resolves a `GroupCategory` to the matching `lucide-react` icon
 * component. The category → icon-name mapping itself lives in
 * `@splitfiesta/shared` so web and mobile stay in lock-step (DRY) —
 * we just bind the names to this platform's lucide package here.
 */
export function getGroupCategoryIcon(
  category: GroupCategory | undefined
): React.ComponentType<React.SVGProps<SVGSVGElement>> {
  const name = getGroupCategoryIconName(category);
  return (Icons as Record<LucideIconName, React.ComponentType<unknown>>)[
    name
  ] as React.ComponentType<React.SVGProps<SVGSVGElement>>;
}
